// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>13</span>&nbsp;&nbsp;O my God, make them like thistledown,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;like chaff before the wind.<br> </p> </div></div>";
// Exports
module.exports = code;